module.exports = __webpack_public_path__ + "static/media/polaroid-11.e1731ffe.png";